import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.css';

class RegisterStep extends Component {
  render(){
    let containerClasses = ['register-step-container'];
    if(parseInt(this.props.step, 10) > this.props.currentStep){
      containerClasses.push('disabled');
    }
    return (
      <div className={containerClasses.join(' ')}>

        <div className="register-step">
          <div className="step-title">{this.props.title}</div>
          <div className="step-number"><div className="number">{this.props.step}</div></div>
          <div className="step-substeps-squares">
            {Array(parseInt(this.props.substeps, 10)).fill().map((item, key) => {
              let substepClasses = ['substep-square'];
              if(this.props.substeps < 2) return null;
              if(parseInt(this.props.step, 10) === this.props.currentStep){
                if((parseInt(key, 10) + 1) > this.props.currentSubstep){
                  substepClasses.push('disabled');
                }
              }
              if(parseInt(this.props.step, 10) > this.props.currentStep){
                substepClasses.push('disabled');
              }
              return (
                <div key={key} className={substepClasses.join(' ')}></div>
              );
            })}
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentStep: state.apply.currentStep,
  currentSubstep: state.apply.currentSubstep
})

export default connect(mapStateToProps)(RegisterStep);



// WEBPACK FOOTER //
// ./src/components/RegisterStep/RegisterStep.js